import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[psUiTableCaption]',
})
export class TableCaptionDirective {
  @Input()
  public placement: 'top' | 'bottom' = 'top';

  constructor(public template: TemplateRef<unknown>) {}
}
